import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

import { useStaticPageQuery } from '../../hooks';

const Quality = dynamic(() => import('../corporate/Quality'));
const SeturSelect = dynamic(() => import('../setur/SeturSelect'));
const SeturBiz = dynamic(() => import('../setur/SeturBiz'));
const CustomerRelations = dynamic(
  () => import('../corporate/CustomerRelations')
);
const ContactUs = dynamic(() => import('../corporate/ContactUs'));
const StaticPage = dynamic(() => import('./StaticPage'));

//this component is responsible from data providing having common services
//URL's are divided into corporate and sites
//static pages are all under one service
const StaticPageContainer = () => {
  const params = useParams();
  const { slug = '' } = params as Record<string, string>;
  const { data } = useStaticPageQuery({
    slug: slug as string,
  });

  if (!data) return null;

  let StaticPageComponent: React.ElementType;

  switch (slug) {
    case 'kalite':
      StaticPageComponent = Quality;
      break;
    case 'setur-select':
      StaticPageComponent = SeturSelect;
      break;
    case 'seturbiz':
      StaticPageComponent = SeturBiz;
      break;
    case 'iletisim':
      StaticPageComponent = ContactUs;
      break;
    case 'musteri-iliskileri':
      StaticPageComponent = CustomerRelations;
      break;
    default:
      StaticPageComponent = StaticPage;
      break;
  }

  return <StaticPageComponent {...data} />;
};

export default StaticPageContainer;
